<template>
  <v-tooltip left v-if="hasRecords">
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" small fab @click.stop="viewRecords">
        <v-icon color="appMain">description</v-icon>
      </v-btn>
    </template>
    <span>Show my answers</span>
  </v-tooltip>
</template>

<script>
import { mapGetters, mapState, mapMutations } from 'vuex';
import { eventBus } from '@/lib/events';

export default {
  name: 'ShowGuestAnswersButton',
  computed: {
    ...mapState('rooms', ['guestAnswers', 'roomInfo']),
    ...mapGetters('rooms', ['isHost']),
    hasRecords() {
      return !this.isHost && !!this.guestAnswers;
    },
  },
  watch: {
    'roomInfo.identity': {
      immediate: true,
      handler() {
        this.extractStoredAnswersForGuest();
      },
    },
  },
  methods: {
    ...mapMutations('rooms', ['extractGuestAnswers']),
    viewRecords() {
      eventBus.trigger('showParticipantAnswers', {
        participantId: this.roomInfo.identity,
      });
    },
    extractStoredAnswersForGuest() {
      if (this.isHost || !this.roomInfo) return;
      this.extractGuestAnswers();
    },
  },
};
</script>
